const images = import.meta.glob(
  "../../../assets/workspaceIcon/*.{png,jpg,jpeg,svg}",
  { eager: true }
);

// Normalize names here (single source of truth)
const normalizeName = (name: string) =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")     // spaces → hyphen
    .replace(/[^a-z0-9-]/g, ""); // remove special chars

export const getWorkspaceImage = (name?: string): string | null => {
  if (!name) return null;

  const normalized = normalizeName(name);

  const match = Object.keys(images).find((path) =>
    path.toLowerCase().includes(normalized)
  );

  return match ? (images[match] as any).default : null;
};
